// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FeqXc","tabsBox":"styles_tabsBox__1rvHj","createButton":"styles_createButton__3tkB9"};